import { useEffect, useState } from "react";
import { fetchReferralHistory } from "../../services/profileService";

export default function ReferralHistory() {
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filter, setFilter] = useState({
    startDate: "All",
    endDate: "All",
  });

  const loadReferralHistory = async () => {
    setLoading(true);

    try {
      const data = await fetchReferralHistory(
        filter.startDate,
        filter.endDate
      );

      if (data.status) {
        setReferrals(data.data || []);
      }
    } catch (err) {
      console.error("Referral load error:", err);
    }

    setLoading(false);
  };

  useEffect(() => {
    loadReferralHistory();
  }, [filter]);

  return (
    <div className="profile-card">
      <h3>Referral History</h3>

      {/* ===== DATE FILTER ===== */}
      <div className="wallet-filter">
        <input
          type="date"
          onChange={(e) =>
            setFilter((prev) => ({
              ...prev,
              startDate: e.target.value || "All",
            }))
          }
        />

        <input
          type="date"
          onChange={(e) =>
            setFilter((prev) => ({
              ...prev,
              endDate: e.target.value || "All",
            }))
          }
        />
      </div>

      {/* ===== HISTORY LIST ===== */}
      {loading ? (
        <p>Loading...</p>
      ) : referrals.length === 0 ? (
        <p>No referral bonus history found.</p>
      ) : (
        <div className="wallet-list">
          {referrals.map((item, index) => (
            <div key={index} className="wallet-item">
              <div>
                <strong>Referral Bonus</strong>
                <p>
                  {new Date(item.createdAt).toLocaleDateString()}
                </p>
              </div>

              <div className="wallet-amount">
                <span className="amount-positive">
                  + {item.coin} Coins
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
